/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Routes from 'fierry/rpc/routes';

import { createGalaxyRoutes } from 'solis/rpc/galaxy';
import { createAccountRoutes } from 'solis/rpc/account';
import { createColonyRoutes } from 'solis/rpc/colony';
import { createBoardRoutes } from 'solis/rpc/board';


const routes = new Routes();

createGalaxyRoutes(routes);
createAccountRoutes(routes);
createColonyRoutes(routes);
createBoardRoutes(routes);


export default routes;
